/**
 * Bio component.
 */

import React from "react"
import { bioWrapper } from "./bio.css";

const Bio = () => {
  return (
    <div className={bioWrapper}>
      <p>
        KJ Monahan is a Technical Engineer at <a href="https://www.forumone.com">Forum One</a>. All opinions and mistakes are their own.
      </p>
    </div>
  )
}

export default Bio
